import React from 'react';
import { Box, Typography } from '@mui/material';
import { AdminConfirmProvider } from '../shared/AdminConfirmProvider';
import { FormFieldConfigsForm } from './FormFieldConfigsForm';

/**
 * Admin client config: edit the client form fields of the default, a ledger or a broker
 * group, and copy or reset them (FormFieldConfigsForm).
 */
export const FormFieldConfigsPage = () => (
	<AdminConfirmProvider>
		<Box sx={{ p: 1, pb: 2, width: '100%' }}>
			<Typography>
				Client form fields for the default, a ledger or a broker group. Changes are saved
				into the one picked. A broker group&apos;s own config wins over its ledger&apos;s,
				which wins over the default.
			</Typography>
		</Box>
		<FormFieldConfigsForm />
	</AdminConfirmProvider>
);

FormFieldConfigsPage.displayName = 'FormFieldConfigsPage';
